
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import NavbarSearch from "./NavbarSearch";
import { Crown } from "lucide-react";
import { mainNavItems, adminNavItems, userNavItems, getUserProfileUrl } from "@/config/navigation";
import { Button } from "@/components/ui/button";

interface MobileMenuProps {
  isOpen: boolean;
}

const MobileMenu = ({ isOpen }: MobileMenuProps) => {
  const { user, isAdmin, signOut } = useAuth();
  
  if (!isOpen) return null;
  
  return (
    <div className="md:hidden fixed inset-x-0 top-16 p-4 bg-background border-b border-border z-30 shadow-lg animate-in slide-in-from-top-5">
      <NavbarSearch isMobile={true} />
      
      <div className="flex flex-col space-y-3 mt-3">
        {/* Main Navigation Links */}
        {mainNavItems
          .filter(item => !item.requiresAuth || user)
          .map(item => (
            <Link 
              key={item.href}
              to={item.href} 
              className="px-3 py-2 rounded-md hover:bg-muted flex items-center"
            >
              {item.icon && <item.icon className="mr-2 h-4 w-4" />}
              {item.title}
            </Link>
          ))}
        
        {/* Admin Links */}
        {isAdmin && (
          <>
            <div className="border-t border-border my-2" />
            {adminNavItems.map(item => (
              <Link 
                key={item.href}
                to={item.href} 
                className="px-3 py-2 rounded-md hover:bg-muted flex items-center"
              >
                {item.icon && <item.icon className="mr-2 h-4 w-4" />}
                {item.title}
                {item.title === "Product Copilot" && <Crown className="ml-1.5 h-3 w-3 text-amber-400" />}
              </Link>
            ))}
          </>
        )}
        
        {/* Authentication Links */}
        {user ? (
          <>
            <div className="border-t border-border my-2" />
            {userNavItems.map(item => (
              <Link 
                key={item.href}
                to={item.href === "/profile" ? getUserProfileUrl(user.id) : item.href} 
                className="px-3 py-2 rounded-md hover:bg-muted flex items-center"
              >
                {item.icon && <item.icon className="mr-2 h-4 w-4" />}
                {item.title}
              </Link>
            ))}
            <Button 
              variant="destructive" 
              className="mt-2 w-full justify-start"
              onClick={() => signOut()}
            >
              Sign Out
            </Button>
          </>
        ) : (
          <>
            <div className="border-t border-border my-2" />
            <Link 
              to="/sign-in" 
              className="px-3 py-2 rounded-md hover:bg-muted"
            >
              Sign In
            </Link>
            <Link 
              to="/sign-up" 
              className="px-3 py-2 rounded-md hover:bg-muted"
            >
              Sign Up
            </Link>
          </>
        )}
      </div>
    </div>
  );
};

export default MobileMenu;
